// src/components/ui/LoadingOverlay.jsx
export default function LoadingOverlay({ loading }) {
  if (!loading) return null;

  return (
    <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-20 rounded-xl">
      <div className="flex flex-col items-center">
        <div className="w-10 h-10 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        <p className="mt-2 text-gray-700 font-medium">Cargando...</p>
      </div>
    </div>
  );
}
